import React, { useEffect, useState } from "react";
import "../styles/CreateRequisition.scss";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import { Country, State, City } from "country-state-city";
import {
  createRequisition,
  getAllDepartments,
  getAllJobTypes,
  getAllSkills,
  getActiveClients,
} from "../services/api";

const experienceOptions = [
  { value: 0, label: "0" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10+" },
];

// const statusOptions = [
//   { value: "active", label: "Active" },
//   { value: "on-hold", label: "On-hold" },
//   { value: "closed", label: "Closed" },
// ];

function CreateRequisition() {
  const [form, setForm] = useState({
    // job_id: "",
    job_title: "",
    departments: [],
    recruiters: [],
    client_id: "",
    client_name: "",
    client_website: "",
    min_budget: "",
    max_budget: "",
    job_type: [],
    locations: "",
    notice_period_days: "",
    openings: "1",
    job_desc: "",
    skills: [],
    skillInput: "",
    years_of_exp: 0,
    // status: "active",
    remarks: "",
  });

  const [error, setError] = useState("");
  const [skillOptions, setSkillOptions] = useState([]);

  const [locationOptions, setLocationOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [jobTypeOptions, setJobTypeOptions] = useState([]);
  const navigate = useNavigate();
  const created_by =
    localStorage.getItem("user_id") || localStorage.getItem("created_by");

  // const handleRecruitersChange = (selected) => {
  //   setForm((f) => ({
  //     ...f,
  //     recruiters: selected ? selected.map((opt) => opt.value) : [],
  //   }));
  // };

  const handleSkillsChange = (selected) => {
    setForm((f) => ({
      ...f,
      skills: selected ? selected.map((opt) => opt.value) : [],
    }));
  };

  const handleJobTypeChange = (selected) => {
    setForm((f) => ({
      ...f,
      job_type: selected ? selected.map((opt) => opt.value) : [],
    }));
  };

  const handleLocationsChange = (selected) => {
    setForm((f) => ({
      ...f,
      locations: selected ? selected.value : "",
    }));
  };

  const handleDepartmentChange = (selected) => {
    setForm((f) => ({
      ...f,
      departments: selected ? selected.value : "",
    }));
  };

  const handleClientNameChange = (selected) => {
    if (selected) {
      setForm((f) => ({
        ...f,
        client_id: selected.value,
        client_name: selected.label,
        client_website: selected.website || "",
      }));
    } else {
      setForm((f) => ({
        ...f,
        client_id: "",
        client_name: "",
        client_website: "",
      }));
    }
  };

  const handleClientWebsiteChange = (selected) => {
    if (selected) {
      setForm((f) => ({
        ...f,
        client_id: selected.value,
        client_name: selected.label,
        client_website: selected.website || "",
      }));
    } else {
      setForm((f) => ({
        ...f,
        client_id: "",
        client_name: "",
        client_website: "",
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    // Validation using SweetAlert
    const validations = [
      // { condition: !form.job_id.trim(), title: "Missing Job ID", text: "Please enter the job id." },
      {
        condition: !form.job_title.trim(),
        title: "Missing Job Title",
        text: "Please enter the job title.",
      },
      {
        condition: form.departments.length === 0,
        title: "Missing Departments",
        text: "Please select department.",
      },
      // { condition: form.recruiters.length === 0, title: "Missing Recruiters", text: "Please select at least one recruiter." },
      {
        condition:
          form.years_of_exp === "" ||
          form.years_of_exp === null ||
          form.years_of_exp === undefined,
        title: "Missing Experience Level",
        text: "Please enter experience level.",
      },
      // { condition: !form.status, title: "Missing Status", text: "Please select a status." },
      {
        condition: !form.job_desc.trim(),
        title: "Missing Job Description",
        text: "Please enter the job description.",
      },
      {
        condition: form.skills.length === 0,
        title: "Missing Skills",
        text: "Please add at least one skill.",
      },
      {
        condition: form.job_type.length === 0,
        title: "Missing Job Type",
        text: "Please add Job Type.",
      },
      {
        condition: !form.locations,
        title: "Missing Locations",
        text: "Please add location.",
      },
      // {
      //   condition: !form.min_budget.trim() || Number(form.min_budget) <= 0,
      //   title: "Invalid Min Budget",
      //   text: "Please enter a valid minimum budget (must be greater than 0).",
      // },
      // {
      //   condition: !form.max_budget.trim() || Number(form.max_budget) <= 0,
      //   title: "Invalid Max Budget",
      //   text: "Please enter a valid maximum budget (must be greater than 0).",
      // },
      // {
      //   condition: parseFloat(form.max_budget) <= parseFloat(form.min_budget),
      //   title: "Invalid Budget Range",
      //   text: "Max budget must be greater than min budget.",
      // },
      {
        condition:
          !form.min_budget ||
          !form.min_budget.toString().trim() ||
          isNaN(Number(form.min_budget)) ||
          Number(form.min_budget) <= 0,
        title: "Invalid Min Budget",
        text: "Please enter a valid minimum budget.",
      },
      {
        condition:
          !form.max_budget ||
          !form.max_budget.toString().trim() ||
          isNaN(Number(form.max_budget)) ||
          Number(form.max_budget) <= 0,
        title: "Invalid Max Budget",
        text: "Please enter a valid maximum budget.",
      },
      {
        condition:
          form.min_budget &&
          form.max_budget &&
          !isNaN(Number(form.min_budget)) &&
          !isNaN(Number(form.max_budget)) &&
          Number(form.max_budget) <= Number(form.min_budget),
        title: "Invalid Budget Range",
        text: "Max budget must be greater than min budget.",
      },
      {
        condition:
          !form.notice_period_days.trim() ||
          Number(form.notice_period_days) <= 0,
        title: "Invalid Notice Period",
        text: "Please enter a valid notice period.",
      },
      {
        condition: !form.openings.trim() || Number(form.openings) <= 0,
        title: "Invalid Openings",
        text: "Please enter a valid number of openings.",
      },
      {
        condition: !form.client_id,
        title: "Missing Client",
        text: "Please select a client name.",
      },
    ];

    for (let v of validations) {
      if (v.condition) {
        Swal.fire({ icon: "warning", title: v.title, text: v.text });
        return;
      }
    }

    // Show loader
    Swal.fire({
      html: `<img src=${require("../assets/loader.gif")} style="width: 50px" alt="loader">`,
      showConfirmButton: false,
      heightAuto: false,
      customClass: { popup: "loader-swal" },
      allowOutsideClick: false,
    });

    const payload = {
      job_id: form.job_id,
      job_title: form.job_title,
      departments: form.departments ? form.departments : null,
      // recruiters: form.recruiters.length === 1 ? form.recruiters[0] : form.recruiters,
      client_id: form.client_id,
      min_budget: parseFloat(form.min_budget),
      max_budget: parseFloat(form.max_budget),
      job_type: form.job_type ? form.job_type : null,
      locations: form.locations ? form.locations : null,
      notice_period_days: Number(form.notice_period_days),
      openings: Number(form.openings),
      job_desc: form.job_desc,
      skills: form.skills.join(", "),
      years_of_exp: form.years_of_exp?.toString()?.endsWith("-") && form.years_of_exp.slice(0, -1) || form.years_of_exp,
      // status: form.status,
      remarks: form.remarks,
      created_by: created_by,
    };

    createRequisition(payload)
      .then((res) => {
        Swal.close(); // Close loader

        if (
          res?.error_code === 409 ||
          res?.error_info === "job_id already exists"
        ) {
          Swal.fire({
            icon: "error",
            title: "Job ID already exists",
            text: "Please use a unique Job ID.",
            confirmButtonColor: "#0078b9",
          });
          return;
        }

        if (res?.status === "E") {
          setError(
            res.error_info || "Failed to create requisition. Please try again."
          );
          return;
        }

        if (res?.status === "S") {
          const matchingCount =
            res?.result_info?.matching_candidates_count || 0;
          Swal.fire({
            icon: "success",
            title: "Requisition created successfully!",
            html:
              matchingCount > 0
                ? `<span style="color:#0078b9;">
                ${matchingCount} candidate${
                    matchingCount === 1 ? "" : "s"
                  } matched for this requisition
              </span>`
                : `<span style="color:#0078b9;">
                No matching candidates found for this requisition.
              </span>`,
            confirmButtonColor: "#0078b9",
            confirmButtonText: "OK",
          }).then(() => navigate("/requisitions"));
          return;
        }

        if (
          res?.status === "F" &&
          res?.message === "Unauthorized - Missing token"
        ) {
          Swal.fire({
            text: "Please login with your credentials",
            icon: "warning",
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            localStorage.clear();
            navigate("/login");
          });
          return;
        }

        if (
          res?.status === "F" &&
          res?.message === "Unauthorized - Invalid token"
        ) {
          Swal.fire({
            text: "Please login with your credentials",
            icon: "warning",
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            localStorage.clear();
            navigate("/login");
          });
          return;
        }

        // Fallback error display
        Swal.fire({
          icon: "error",
          title: "Something went wrong!",
          text: res?.message || "Unknown error occurred.",
        });
      })
      .catch(() => {
        Swal.close();
        setError("Failed to create requisition. Please try again.");
      });
  };

  // For Departments, Job Types, Skills, Locations, Recruiters
  const fetchSkills = async (query) => {
    try {
      const response = await getAllSkills();
      if (
        response &&
        response.result_code === 200 &&
        Array.isArray(response.result_info)
      ) {
        const allSkills = response.result_info.map(
          (skill) => skill.skill_name || skill.name || skill
        );
        if (!query) return allSkills;
        return allSkills.filter((skill) =>
          skill.toLowerCase().includes(query.toLowerCase())
        );
      }
      return [];
    } catch (error) {
      console.error("Error fetching skills:", error);
      return [];
    }
  };

  // Function to get Indian cities
  const getIndianCities = () => {
    try {
      // Get India country code
      const india = Country.getCountryByCode("IN");
      if (!india) return [];

      // Get all states of India
      const indianStates = State.getStatesOfCountry("IN");
      if (!indianStates || indianStates.length === 0) return [];

      // Get cities from all states
      const allCities = [];
      indianStates.forEach((state) => {
        const cities = City.getCitiesOfState("IN", state.isoCode);
        if (cities && cities.length > 0) {
          cities.forEach((city) => {
            allCities.push({
              value: city.name,
              label: `${city.name}`,
            });
          });
        }
      });

      // Sort cities alphabetically
      return allCities.sort((a, b) => a.label.localeCompare(b.label));
    } catch (error) {
      console.error("Error fetching Indian cities:", error);
      return [];
    }
  };

  useEffect(() => {
    let active = true;

    // 🔹 Fetch Skills
    fetchSkills("").then((skills) => {
      if (active && Array.isArray(skills)) {
        setSkillOptions(skills.map((s) => ({ value: s, label: s })));
      }
    });

    // 🔹 Fetch Indian Cities
    const indianCities = getIndianCities();
    if (active) {
      setLocationOptions(indianCities);
    }

    // 🔹 Fetch Departments
    getAllDepartments().then((res) => {
      if (active) {
        if (res?.status === "S" && Array.isArray(res.result_info)) {
          setDepartmentOptions(
            res.result_info.map((dept) => ({
              value: dept.id,
              label: dept.name,
            }))
          );
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed to fetch departments",
            text: res?.error_info || "No department data found.",
          });
          setDepartmentOptions([]);
        }
      }
    });

    // 🔹 Fetch Active Clients
    getActiveClients().then((res) => {
      if (active) {
        if (res?.status === "S" && Array.isArray(res.result_info)) {
          setClientOptions(
            res.result_info.map((client) => ({
              value: client.id,
              label: client.name,
              website: client.website,
            }))
          );
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed to fetch active clients",
            text: res?.error_info || "No active client data found.",
          });
          setClientOptions([]);
        }
      }
    });

    // 🔹 Fetch Job Types
    getAllJobTypes().then((res) => {
      if (active) {
        if (res?.status === "S" && Array.isArray(res.result_info)) {
          setJobTypeOptions(
            res.result_info.map((jobType) => ({
              value: jobType.id,
              label: jobType.name,
            }))
          );
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed to fetch job types",
            text: res?.error_info || "No job types found.",
          });
          setJobTypeOptions([]);
        }
      }
    });

    // 🔚 Cleanup to avoid memory leaks
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="create-requisition-container">
      <h2 style={{ fontWeight: 600, fontSize: "1.4rem" }}>
        Create Requisition
      </h2>
      {/* Basic Information */}
      <div className="create-requisition-section">
        <div className="create-requisition-section-title">
          <span role="img" aria-label="info">
            🔵
          </span>{" "}
          Basic Information
        </div>
        <div className="create-requisition-row">
          {/* <div className="create-requisition-field">
            <label>Job ID *</label>
            <input
              name="job_id"
              value={form.job_id || ""}
              onChange={(ev) => {
                const value = ev.target.value;
                const invalidPattern =
                  /<script.*?>.*?<\/script>|[<>\\{}=:/""'']/i;
                if (!invalidPattern.test(value)) {
                  setForm({ ...form, job_id: value });
                }
              }}
              maxLength={255}
              placeholder="Enter Job ID"
              required
              className="custom-placeholder"
              autoComplete="off"
            />
          </div> */}
          <div className="create-requisition-field">
            <label>Job Title *</label>
            <input
              name="job_title"
              value={form.job_title}
              onChange={(ev) => {
                const value = ev.target.value;

                // Don't allow if it doesn't start with a letter (but allow empty string)
                if (value !== "" && !/^[a-zA-Z]/.test(value)) {
                  return; // Reject if doesn't start with letter
                }

                const invalidPattern =
                  /<script.*?>.*?<\/script>|[<>\\{}=:/""'']/i;
                if (!invalidPattern.test(value)) {
                  setForm({ ...form, job_title: value });
                }
              }}
              placeholder="Enter job title"
              required
              className="custom-placeholder"
              autoComplete="off"
            />
          </div>
        </div>
        <div className="create-requisition-row">
          <div className="create-requisition-field">
            <label>Department *</label>
            <Select
              // isMulti
              options={departmentOptions}
              value={
                departmentOptions.find(
                  (opt) => opt.value === (form.departments || "")
                ) || null
              }
              // value={
              //   // departmentOptions.filter((opt) =>
              //     form.departments
              //   // )
              // }
              // onChange={handleDepartmentChange}
              onChange={(selected) =>
                setForm((f) => ({
                  ...f,
                  departments: selected ? selected.value : "",
                }))
              }
              placeholder="Select department"
              isSearchable={false}
              classNamePrefix="react-select"
              styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>
          {/* <div className="create-requisition-field">
            <label>Recruiters *</label>
            <Select
              isMulti
              options={recruiterOptions}
              value={recruiterOptions.filter((opt) =>
                form.recruiters.includes(opt.value)
              )}
              onChange={handleRecruitersChange}
              placeholder="Select recruiter(s)"
              isSearchable={true}
              classNamePrefix="react-select"
              styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div> */}
        </div>
        <div className="create-requisition-row">
          <div className="create-requisition-field">
            <label>Openings *</label>
            <input
              type="text"
              name="openings"
              value={form.openings}
              onChange={(ev) => {
                const value = ev.target.value;
                const digitOnlyPattern = /^\d*$/; // Allow any number of digits
                if (digitOnlyPattern.test(value)) {
                  setForm({ ...form, openings: value });
                }
              }}
              placeholder="Number of openings"
              required
              min="1"
              autoComplete="off"
            />
          </div>
          <div className="create-requisition-field">
            <label>Experience Level (Years) *</label>
            {/* <Select
              options={experienceOptions}
              value={
                experienceOptions.find(
                  (opt) => opt.value === Number(form.years_of_exp)
                ) || null
              }
              onChange={(selected) =>
                setForm((f) => ({
                  ...f,
                  years_of_exp: selected !== null ? selected.value : "",
                }))
              }
              placeholder="Select experience level"
              isSearchable={true}
              classNamePrefix="react-select"
              styles={{
                control: (base, state) => ({
                  ...base,
                  padding: "0.15rem 0", // adjust as needed
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
              isClearable
            /> */}

            <input
              name="experience"
              type="text"
              min="0"
              value={form.years_of_exp}
              // onChange={(ev) => {
              //   const value = ev.target.value;
              //   const digitOnlyPattern = /^[\d-]*$/; // Allow any number of digits
              //   if (digitOnlyPattern.test(value)) {
              //     setForm({ ...form, years_of_exp: value });
              //   }
              // }}
              onChange={(ev) => {
                const value = ev.target.value;

                // Allow empty string
                if (value === "") {
                  setForm({ ...form, years_of_exp: value });
                  return;
                }

                // Allow only digits and hyphens
                if (!/^[\d-]*$/.test(value)) {
                  return;
                }

                // Don't allow starting with hyphen
                if (value.startsWith("-")) {
                  return;
                }

                // Don't allow consecutive hyphens
                if (value.includes("--")) {
                  return;
                }

                // Allow the input (even if it temporarily ends with hyphen while typing)
                setForm({ ...form, years_of_exp: value });
              }}
              onKeyDown={(e) => {
                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                  e.preventDefault();
                }
              }}
              // maxLength={255}
              autoComplete="off"
              placeholder="Enter experience level"
              className="custom-placeholder"
            />
          </div>
        </div>
        {/*  <div className="create-requisition-row">
         Only show for Admin (1) and Hiring Manager (3) 
          {(localStorage.getItem("role_id") === "1" ||
            localStorage.getItem("role_id") === "3") && (
            <div className="create-requisition-field">
              <label>Status *</label>
              <Select
                options={statusOptions}
                value={
                  statusOptions.find((opt) => opt.value === form.status) || null
                }
                onChange={(selected) =>
                  setForm((f) => ({
                    ...f,
                    status: selected ? selected.value : "active",
                  }))
                }
                placeholder="Select status"
                isSearchable={true}
                classNamePrefix="react-select"
                styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          )}
        </div> */}
      </div>
      {/* Job Details */}
      <div className="create-requisition-section">
        <div className="create-requisition-section-title">
          <span role="img" aria-label="details">
            🟦
          </span>{" "}
          Job Details
        </div>
        <div className="create-requisition-row">
          <div className="create-requisition-field" style={{ flex: 2 }}>
            <label>Job Description *</label>
            <textarea
              name="job_desc"
              value={form.job_desc}
              onChange={(ev) => {
                const value = ev.target.value;
                const invalidPattern =
                  /<script.*?>.*?<\/script>|[<>\\{}=:/""'']/i;
                if (!invalidPattern.test(value)) {
                  setForm({ ...form, job_desc: value });
                }
              }}
              placeholder="Provide a detailed description of the role, responsibilities, and requirements..."
              rows="4"
              className="custom-placeholder"
            />
          </div>
        </div>
        <div className="create-requisition-row">
          <div className="create-requisition-field" style={{ flex: 2 }}>
            <label>Skills *</label>
            <Select
              isMulti
              options={skillOptions}
              value={skillOptions.filter((opt) =>
                form.skills.includes(opt.value)
              )}
              onChange={handleSkillsChange}
              placeholder="Select or type skills"
              isSearchable={true}
              classNamePrefix="react-select"
              styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>
        </div>
        <div className="create-requisition-row">
          <div className="create-requisition-field">
            <label>Job Type *</label>
            <Select
              // isMulti
              options={jobTypeOptions}
              value={
                jobTypeOptions.find(
                  (opt) => opt.value === (form.job_type || "")
                ) || null
              }
              // value={
              //   jobTypeOptions.filter((opt) =>
              //     form.job_type.includes(opt.value)
              //   )
              // }
              // onChange={handleJobTypeChange}
              onChange={(selected) =>
                setForm((f) => ({
                  ...f,
                  job_type: selected ? selected.value : "",
                }))
              }
              placeholder="Select job type"
              isSearchable={true}
              classNamePrefix="react-select"
              styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>
          <div className="create-requisition-field">
            <label>Location *</label>
            <Select
              options={locationOptions}
              value={
                locationOptions.find((opt) => opt.value === form.locations) ||
                null
              }
              onChange={handleLocationsChange}
              placeholder="Select location"
              isSearchable={true}
              classNamePrefix="react-select"
              styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>
        </div>
        <div className="create-requisition-row">
          <div className="create-requisition-field">
            <label>Min Budget (in lakhs) *</label>
            <input
              type="text"
              name="min_budget"
              value={form.min_budget}
              onChange={(ev) => {
                const value = ev.target.value;

                const isValidNumber =
                  /^\d*\.?\d*$/.test(value) && !value.startsWith(".");

                if (isValidNumber) {
                  setForm({ ...form, min_budget: value });
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                  e.preventDefault();
                }
              }}
              placeholder="Enter minimum budget"
              required
              min="0"
              // step="0.01"
              autoComplete="off"
            />
          </div>
          <div className="create-requisition-field">
            <label>Max Budget (in lakhs) *</label>
            <input
              type="text"
              name="max_budget"
              value={form.max_budget}
              onChange={(ev) => {
                const value = ev.target.value;
                const isValidNumber =
                  /^\d*\.?\d*$/.test(value) && !value.startsWith(".");

                if (isValidNumber) {
                  setForm({ ...form, max_budget: value });
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                  e.preventDefault();
                }
              }}
              placeholder="Enter maximum budget"
              required
              min="0"
              // step="0.01"
              autoComplete="off"
            />
          </div>
        </div>
        <div className="create-requisition-row">
          <div className="create-requisition-field">
            <label>Notice Period in Days *</label>
            <input
              type="text"
              name="notice_period_days"
              value={form.notice_period_days}
              onChange={(ev) => {
                const value = ev.target.value;
                const isValidNumber = /^\d*$/.test(value);

                if (isValidNumber) {
                  setForm({ ...form, notice_period_days: value });
                }
              }}
              min={1}
              placeholder="Enter notice period in days"
              required
              autoComplete="off"
              onKeyDown={(e) => {
                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                  e.preventDefault();
                }
              }}
            />
          </div>
        </div>
      </div>
      {/* Additional Information */}
      <div className="create-requisition-section">
        <div className="create-requisition-section-title">
          <span role="img" aria-label="status">
            🟦
          </span>{" "}
          Additional Information
        </div>
        <div className="create-requisition-row">
          <div className="create-requisition-field">
            <label>Client Name *</label>
            <Select
              options={clientOptions}
              value={
                clientOptions.find((opt) => opt.value === form.client_id) ||
                null
              }
              onChange={handleClientNameChange}
              placeholder="Select client name"
              isSearchable={true}
              classNamePrefix="react-select"
              styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }}
              isClearable
            />
          </div>
          <div className="create-requisition-field">
            <label>Client Website *</label>
            <Select
              options={clientOptions}
              value={
                clientOptions.find((opt) => opt.value === form.client_id) ||
                null
              }
              onChange={handleClientWebsiteChange}
              placeholder="Select client website"
              isSearchable={true}
              classNamePrefix="react-select"
              styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }}
              isClearable
              getOptionLabel={(option) => option.website}
              getOptionValue={(option) => option.value}
              isDisabled
            />
          </div>
        </div>

        <div className="create-requisition-row">
          <div className="create-requisition-field" style={{ flex: 2 }}>
            <label>Remarks</label>
            <textarea
              name="remarks"
              value={form.remarks}
              onChange={(ev) => {
                const value = ev.target.value;
                const invalidPattern =
                  /<script.*?>.*?<\/script>|[<>\\{}=:/""'']/i;
                if (!invalidPattern.test(value)) {
                  setForm({ ...form, remarks: value });
                }
              }}
              placeholder="Additional notes or remarks..."
              rows="3"
              className="custom-placeholder"
              autoComplete="off"
            />
          </div>
        </div>
      </div>

      {error && (
        <div style={{ color: "red", marginBottom: "1rem" }}>{error}</div>
      )}
      <div className="create-requisition-actions">
        <button
          type="button"
          onClick={() => {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "instant", // No smooth scrolling
            });
            navigate("/requisitions");
          }}
          className="cancel-btn"
        >
          Cancel
        </button>
        <button onClick={handleSubmit} className="save-btn">
          Create
        </button>
      </div>
    </div>
  );
}

export default CreateRequisition;
